import { useEffect, useState } from 'react';
import { useAuth } from "./auth/AuthProvider";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import './App.css';
import './Home.css'; // Importa o novo CSS
import Charge, { ChargeHeader, ChargerMenu } from "./screens/Charge";
import Wallet, { WalletHeader, WalletMenu } from './screens/Wallet';
import Station, { StationHeader, StationMenu } from './screens/Station';
import Title from './components/Title';
import { ReactComponent as EletropostoIcon } from './images/eletroposto.svg';
import eletropostoPic from './images/eletroposto.png'; // Importa a imagem
import Menu from './components/Menu';
import { Card } from 'primereact/card';
import { EstacaoType, ConectorType, StationStatus, StationType } from './screens/Station';
import { useNavigate } from 'react-router-dom';
import * as API from './services/API';
import History, { HistoryHeader, HistoryMenu } from "./screens/History";
import Profile, { ProfileHeader, ProfileMenu } from "./screens/Profile";
function Home() {
  const [balance, setBalance] = useState('--')
  const [chargeState, setChargeState] = useState(0)
  const [stations, setStations] = useState<EstacaoType[]>([])
  const [station, setStation] = useState<EstacaoType | null>(null)
  const [conector, setConector] = useState<ConectorType | null>(null)
  const authenticator = useAuth()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [loadingStatus, setLoadingStatus] = useState(true)
  const refreshBalance = async () => {
    setBalance(await authenticator.getBalance())
  }
  useEffect(() => {
    const getEstacoes = async () => {
      setLoading(true)
      const data = await API.getEstacoes(authenticator.token)

      setStations(data.map((e: any) => ({
        ...e,
        status: 'OFFLINE' as StationStatus
      })))
      setLoading(false)
    };
    if (authenticator.token) {
      refreshBalance()
      getEstacoes();
    }

  }, [authenticator.token]);
  const getStatus = async () => {
    setLoadingStatus(true)
    try {
      const response = await fetch(`https://api.eletroposto.gearspark.com.br/api/stations`, { headers: { 'Authorization': `Bearer ${authenticator.token}` } });
      const data = await response.json();
      setStations((prevEstacoes: EstacaoType[]) => {
        return prevEstacoes.map(e => {
          const s = data.stations.find((s: StationType) => s.identity === e.identidade)
          if (s)
            return {
              ...e,
              status: s.statelabel === 'Available' ?
                'LIVRE' :
                s.statelabel === 'Preparing' || s.statelabel === 'Charging' || s.statelabel === 'SuspendedEVSE' || s.statelabel === 'SuspendedEV' ?
                  'OCUPADO' :
                  s.statelabel === 'Unavailable' || s.statelabel === 'Faulted' ?
                    'OFFLINE' : 'ONLINE'
            }
          else
            return { ...e }
        }); // Reset all to OFFLINE
      }); // Gatilho para re-renderizar a lista

      setLoadingStatus(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
    }
  };
  useEffect(() => {
    if (stations.length > 0)
      getStatus();

  }, [stations.length]);


  useEffect(() => {
    if (authenticator.token === '')
      navigate('/')
  }, [])

  const [indexMenu, setIndexMenu] = useState(0)
  const footer = () => {
    return <Menu index={indexMenu} setIndex={setIndexMenu} menuItems={[ChargerMenu(), StationMenu(), WalletMenu(), HistoryMenu(), ProfileMenu()]} />
  }
  const title = () => {
    if (indexMenu === 1)
      return <Title title={StationHeader().title} subtitle={StationHeader().subtitle} icon={() => StationHeader().icon} showReturn />
    else if (indexMenu === 2)
      return <Title title={WalletHeader().title} subtitle={WalletHeader().subtitle} icon={() => WalletHeader().icon} showReturn />
    else if (indexMenu === 3)
      return <Title title={HistoryHeader().title} subtitle={HistoryHeader().subtitle} icon={() => HistoryHeader().icon} showReturn />
    else if (indexMenu === 4)
      return <Title title={ProfileHeader().title} subtitle={ProfileHeader().subtitle} icon={() => ProfileHeader().icon} showReturn />
    return <Title title={ChargeHeader().title} subtitle={ChargeHeader().subtitle} icon={() => ChargeHeader().icon} showReturn />
  }
  const header = (
    <div className="home-header-image" style={{ backgroundImage: `url(${eletropostoPic})` }}>
      <div className="home-header-overlay">
        <EletropostoIcon width={50} height={50} color="white" />
        <div className="home-header-title-container">
          <div className="home-header-title">
            ELETROPOSTO UFMS
          </div>
          <div className="home-header-subtitle">
            Departamento de Engenharia Elétrica e BATLAB
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="home-container">
      <Card title={title} footer={footer} header={header} className="home-panel">
        <div className="home-content" style={{ paddingTop: 0, paddingBottom: 0, marginTop: -10, marginBottom: -20 }}>
          {indexMenu === 0 && <Charge balance={balance} chargeState={chargeState} setChargeState={setChargeState} setIndex={setIndexMenu} stations={stations} station={station} setStation={setStation} conector={conector} setConector={setConector} loadingStatus={loadingStatus} />}
          {indexMenu === 1 && <Station index={indexMenu} setIndex={setIndexMenu} estacao={station} setEstacao={setStation} estacoes={stations} />}
          {indexMenu === 2 && <Wallet balance={balance} setBalance={setBalance} />}
          {indexMenu === 3 && <History />}
          {indexMenu === 4 && <Profile />}
        </div>
      </Card>
    </div>
  );
}

export default Home;
